<template>
  <div class="modal">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ isNewOperatorTitle ? 'Crear puesto' : 'Editar puesto' }}</h5>
          <button type="button" class="close" @click="closeModal">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <form @submit.prevent="handleSubmit">
          <div class="modal-body">
            <div class="form-group">
              <label for="descrip-input">Descripción:</label>
              <input type="text" v-model="formData.descrip" id="descrip-input" class="form-control" required ref="firstInput"/>
            </div>
            <hr>
            <div class="d-flex justify-content-end">
              <button type="button" class="btn btn-danger me-2" @click="closeModal">Cancelar</button>
              <button type="submit" class="btn btn-success">Guardar</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { showCustomErrorSweetAlert, showCustomSuccessSweetAlert } from '../../common/utils';

export default {
  name: 'OperatorTitleModal',
  props: {
    isNewOperatorTitle: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {

    };
  },
  mounted() {

  },
  methods: {
    handleSubmit() {
      this.isNewOperatorTitle ? this.createOperatorTitle() : this.updateOperatorTitle();
    },
    createOperatorTitle() {
      axios.post('/api/operator-titles', this.formData)
        .then(() => {
          showCustomSuccessSweetAlert('Puesto creado correctamente');
          this.$emit('form-submitted');
          this.closeModal();
        })
        .catch(error => {
          showCustomErrorSweetAlert(error.response.data);
        });
    },
    updateOperatorTitle() {
      axios.patch(`/api/operator-titles/${this.formData.id}`, this.formData)
        .then(() => {
          showCustomSuccessSweetAlert('Item editado correctamente');
          this.$emit('form-submitted');
          this.closeModal();
        })
        .catch(error => {
          showCustomErrorSweetAlert(error.response.data);
        });
    },
    closeModal() {
      this.$emit('close-modal');
    },
  }
};
</script>